import { render, staticRenderFns } from "./storeOrderRecord.vue?vue&type=template&id=e6a603b8&scoped=true"
import script from "./storeOrderRecord.vue?vue&type=script&lang=js"
export * from "./storeOrderRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a603b8",
  null
  
)

export default component.exports